import React from "react";
import api from "../../lib/api";

export default function AdminMessages() {
  const [msgs, setMsgs] = React.useState([]);
  const [selected, setSelected] = React.useState(null);

  const load = () => api.get("/admin/messages").then(r => setMsgs(r.data));
  React.useEffect(() => { load(); }, []);

  const open = async (m) => {
    setSelected(m);
    if (!m.lu) {
      await api.patch(`/admin/messages/${m.id}/read`);
      load();
    }
  };

  return (
    <div data-testid="admin-messages">
      <div className="eyebrow mb-2">Boîte de réception</div>
      <h1 className="h-display text-4xl md:text-5xl">Messages.</h1>
      <div className="grid md:grid-cols-[400px_1fr] gap-6 mt-10">
        <div className="border border-white/10 max-h-[70vh] overflow-y-auto">
          {msgs.length === 0 && <div className="p-12 text-center italic text-text-cream/40">Aucun message.</div>}
          {msgs.map(m => (
            <button key={m.id} onClick={() => open(m)} className={`w-full text-left p-4 border-b border-white/5 hover:bg-white/5 transition ${selected?.id===m.id ? "bg-white/5":""}`}>
              <div className="flex justify-between items-start gap-2">
                <div className="font-serif text-lg">{m.nom}</div>
                {!m.lu && <span className="w-2 h-2 bg-accent-deep rounded-full mt-2"/>}
              </div>
              <div className="text-xs text-text-cream/50 truncate">{m.sujet}</div>
              <div className="text-[10px] text-text-cream/40 mt-1">{new Date(m.created_at).toLocaleString("fr-CH")}</div>
            </button>
          ))}
        </div>
        <div className="border border-white/10 p-6 md:p-10 min-h-[400px]">
          {selected ? (
            <div>
              <div className="eyebrow text-accent-light mb-2">{selected.sujet}</div>
              <h2 className="font-serif text-3xl italic">{selected.nom}</h2>
              <div className="text-text-cream/60 text-sm mt-1">{selected.email} {selected.telephone && `· ${selected.telephone}`}</div>
              <div className="mt-8 text-text-cream/80 font-light whitespace-pre-line leading-relaxed">{selected.message}</div>
              <a href={`mailto:${selected.email}?subject=Re: ${encodeURIComponent(selected.sujet)}`} className="btn-primary mt-10 inline-flex">Répondre par email</a>
            </div>
          ) : (
            <div className="italic text-text-cream/40 text-center pt-20">Sélectionne un message pour le lire.</div>
          )}
        </div>
      </div>
    </div>
  );
}
